import React, { useEffect, useState } from 'react';
import { Box, IconButton, Modal, Typography, Grid, Divider } from '@mui/material';
import { GrClose } from 'react-icons/gr';
import ResetButton from '../../Common_Components/ResetButton';
import { Toast } from '../../Common_Components/Toast';
import axiosInstance from '../../axios/axios';

const labelStyle = {
    fontFamily: 'Times New Roman',
    fontWeight: '700',
    fontSize: '18px',
    color: '#333',
};

const valueStyle = {
    fontFamily: 'Times New Roman',
    fontWeight: '500',
    fontSize: '18px',
    color: '#545454',
};

const sectionTitleStyle = {
    fontFamily: 'Times New Roman',
    fontWeight: '700',
    fontSize: '24px',
    color: '#333',
    marginBottom: '10px',
};

const ClientViewModal = ({ open, handleClose, clientId }) => {
    const [clientDetails, setClientDetails] = useState('');

    useEffect(() => {
        const getClientDetails = async () => {
            try {
                const response = await axiosInstance.get(`/clients/view/${clientId}`);
                const { success, client } = response.data;
                if (success) {
                    setClientDetails(client);
                } else {
                    Toast.warning('Client data not found.');
                }
            } catch (error) {
                console.error('Error fetching client data:', error);
                Toast.error('Failed to fetch client data.');
            }
        };
        if (clientId) {
            getClientDetails();
        }
    }, [clientId]);

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 900,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    background: 'linear-gradient(to bottom, #f7f7f7, #e6e6e6)',
                    outline: 'none',
                }}
            >
                {/* Header */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        borderBottom: '2px solid #ddd',
                        pb: 2,
                        mb: 4,
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: 'Times New Roman',
                            fontWeight: '700',
                            fontSize: '32px',
                            color: '#333',
                        }}
                    >
                        Client Details
                    </Typography>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            color: '#333',
                            '&:hover': {
                                color: '#000',
                            },
                        }}
                    >
                        <GrClose />
                    </IconButton>
                </Box>

                {clientDetails ? (
                    <>
                        {/* Personal Details */}
                        <Box mb={4}>
                            <Typography sx={sectionTitleStyle}>Personal Details</Typography>
                            <Grid container spacing={2}>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Name:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.CD_Name || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Point of Contact:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.CD_POC || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Phone:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.CD_Phone || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Email:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.CD_Email || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>

                        <Divider sx={{ mb: 4 }} />

                        {/* Address Details */}
                        <Box mb={4}>
                            <Typography sx={sectionTitleStyle}>Address Details</Typography>
                            <Grid container spacing={2}>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Address:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.CD_Address || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>City:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.CD_City || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>State:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.city_name || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Country:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.country_name || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>

                        <Divider sx={{ mb: 4 }} />

                        {/* Billing Address */}
                        <Box>
                            <Typography sx={sectionTitleStyle}>Billing Details</Typography>
                            <Grid container spacing={2}>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Billing Address:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.CD_BillingAddress || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Billing City:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.CD_Billing_City || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Billing State:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.billing_city_name || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12}>
                                    <Grid item xs={4}>
                                        <Typography sx={labelStyle}>Billing Country:</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography sx={valueStyle}>{clientDetails.billing_country_name || 'N/A'}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Footer */}
                        <Box display="flex" justifyContent="flex-end" mt={4}>
                            <ResetButton label="Close" onClick={handleClose} />
                        </Box>
                    </>
                ) : (
                    <Typography
                        sx={{
                            fontFamily: 'Times New Roman',
                            fontWeight: '600',
                            fontSize: '20px',
                            color: '#999',
                            textAlign: 'center',
                            mt: 4,
                        }}
                    >
                        Loading client details...
                    </Typography>
                )}
            </Box>
        </Modal>
    );
};

export default ClientViewModal;
